import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Backend, SingleResponse} from '@generated-backend-types';
import AuthenticatedUser = Backend.App.Resources.Dashboard.Auth.AuthenticatedUser;
import DashboardLoginData = Backend.App.Data.Dashboard.Auth.DashboardLoginData;
import DashboardLoginResponse = Backend.App.Resources.Dashboard.Auth.DashboardLoginResponse;
import {ApiService} from './api.service';
import UserData = Backend.App.Data.Dashboard.Auth.UserData;
import {PasswordResetData} from '../../entities/password-reset-data.entity';

@Injectable({providedIn: 'root'})
export class AuthenticationService extends ApiService {
  private readonly endpoint = '/auth';

  public login(data: DashboardLoginData): Observable<SingleResponse<DashboardLoginResponse>> {
    return this.http.post<SingleResponse<DashboardLoginResponse>>(this.endpoint + '/login', {
      email: data.email,
      password: data.password
    });
  }

  public logout(): Observable<void> {
    return this.http.post<void>(this.endpoint + '/logout', {});
  }

  public get(): Observable<SingleResponse<AuthenticatedUser>> {
    return this.http.get<SingleResponse<AuthenticatedUser>>(this.endpoint + '/user');
  }

  public update (userData: UserData): Observable<SingleResponse<AuthenticatedUser>> {
    return this.http.put<SingleResponse<AuthenticatedUser>>(this.endpoint + '/user', userData);
  }

  public enableTwoFactorAuth(): Observable<void> {
    return this.http.post<void>(this.endpoint + '/user/two-factor-authentication ', {});
  }

  public confirmTwoFactorAuth(code: string): Observable<void> {
    return this.http.post<void>(this.endpoint + '/user/confirmed-two-factor-authentication ', {code});
  }

  public getTwoFactorAuthQrCode(): Observable<{ svg: string }> {
    return this.http.get<{ svg: string }>(this.endpoint + '/user/two-factor-qr-code');
  }

  public submitTwoFactorAuthChallenge(code: string): Observable<SingleResponse<DashboardLoginResponse>> {
    return this.http.post<SingleResponse<DashboardLoginResponse>>(this.endpoint + '/two-factor-challenge', {code});
  }

  public requestPasswordReset(email: string): Observable<{message: string}> {
    return this.http.post<{message: string}>(this.endpoint + '/forgot-password', {email});
  }

  public setNewPassword(data: PasswordResetData) {
    return this.http.post(this.endpoint + '/reset-password', data);
  }
}
